export const POPUP_FIELD_INFOS = [
  { fieldName: 'Name', label: 'Name' },
  { fieldName: 'UsageCount', label: 'Usage Count' },
  { fieldName: 'total_trav', label: 'Total Travel' },
  { fieldName: 'Total_Time', label: 'Total Time' }
]

export const CLASS_BREAK_COLORS = ['#b95f4c', '#f69a73', '#f2da95', '#ffffff']

export const NO_ACCESS_COLOR = '#050707'

export const LEGEND_ITEMS = [
  { color: '#b95f4c', label: 'Very low' },
  { color: '#f69a73', label: 'Low' },
  { color: '#f2da95', label: 'Moderate' },
  { color: '#ffffff', label: 'Good' },
  { color: '#050707', label: 'No access' }
]

export const ARCGIS_PORTAL_URL = 'https://www.arcgis.com'
